// @mui icons
import Icon from "@mui/material/Icon";

// Pages
import UserProfile from "./user/profile";
// import Dashboard from "./dashboard";
// import DispenseVoucher from "./transact/dispense";
// import OnboardCustomer from "./transact/onboard";
import Campaigns from "./campaigns";
import Agents from "./agents";
import Customers from "./customers";
// import CampaignVouchers from "./campaigns/vouchers";
// import Partners from "./partners";
// import ChurnCampaigns from "./churn_campaigns";
import AgentGroups from "./agents/groups";
// import AccountSales from "./campaigns/sales";
import ReportFilter from "./campaigns/reports";
import DashboardOverview from "./campaigns/dashboard";
import WalletPage from "./wallet";
import Products from "./products";
import Users from "./users";
import ApiIntegrationView from "./api_integrations";
import AccountProfile from "./account";
import DataForms from "./data_forms";
import ShippingRatesPage from "./shipping_rates";
import Trainings from "./trainings";
import BillingPage from "./billing";
import AttendancesPage from "./attendances";
import FieldOsHomePage from "./home";
import AllDataCapturesPage from "./campaigns/data_captures/captures";
import AccountSales from "./campaigns/sales";
import CustomerPoolsPage from "./customers/pools";
import AgentBenefitsPage from "./agent_benefits";
// import LeadBucketsPage from "./leads/buckets";
import AggregatorsPage from "./agents/aggregators";
// import VisitCampaignsPage from "./visit_campaigns";
import LeadProfilesPage from "./leads";
import VisitCampaignsPage from "./visit_campaigns";
import RecipientGroupsPage from "./messaging/groups";
import MessagingHistoryPage from "./messaging/history";
import LeadPipelinesPage from "./leads/pipelines";
import VoiceNumbersPage from "./voice/numbers";
import CallCentersPage from "./voice/call_center/call_centers";
import BillBackPromotionsPage from "./trade_marketing/bill_back";
// import WholesalersPage from "./trade_marketing/wholesalers";
// import OutletsPage from "./trade_marketing/outlets";
import DisplayWinPromotionsPage from "./trade_marketing/daw";
import ProductSamplingPromotionsPage from "./trade_marketing/psa";
import TradeMarketingHomePage from "./trade_marketing";
import BusinessLinesPage from "./voice/business_line";
import CampaignSubscriptionsPage from "./campaigns/subscription";
import VisitTrackersPage from "./visits";
import RetailersPage from "./merchandising/retailers";
import DistributorsPage from "./merchandising/distributors";
import WholesalersPage from "./merchandising/wholesalers";
import RelationshipsPage from "./ops";
import OpsActivitiesPage from "./ops/activities/activities";
import OpsCheckInsPage from "./ops/check_ins";
import OpsActivityLogsPage from "./ops/activities/activity_logs";
import OpsSalesPage from "./ops/sales/sales";
import OpsSalesRulesPage from "./ops/sales/rules";
import InventoryTrackersPage from "./products/tracking/trackers";
import TerritoriesPage from "./territories/territories";
import BoundariesPage from "./territories/boundaries";
// import AdvertsPage from "./promote";

const routes = [
  // {
  //   type: "collapse",
  //   name: "Home",
  //   key: "home",
  //   icon: <Icon fontSize="small">home</Icon>,
  //   route: "/home",
  //   component: <HomeDashboard />,
  //   secure: true,
  // },

  {
    type: "group",
    title: "Field Operations",
    icon: "workspaces",
  },
  {
    type: "collapse",
    name: "Sales",
    key: "sales",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/ops/sales",
    component: <OpsSalesPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Activity Monitor",
    key: "ops/activities/logs",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/ops/activities/overview",
    component: <OpsActivityLogsPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Check-Ins",
    key: "check-ins",
    icon: <Icon fontSize="small">beenhere</Icon>,
    route: "/ops/check-ins",
    component: <OpsCheckInsPage />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Activities",
    key: "ops/activities",
    icon: <Icon fontSize="small">task</Icon>,
    route: "/ops/activities",
    component: <OpsActivitiesPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Sales Rules",
    key: "ops/sales-rules",
    icon: <Icon fontSize="small">gavel</Icon>,
    route: "/ops/sales-rules",
    component: <OpsSalesRulesPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Business Entities",
    key: "ops",
    icon: <Icon fontSize="small">handshake</Icon>,
    route: "/ops",
    component: <RelationshipsPage />,
    secure: true,
  },
  {
    type: "group",
    title: "Field Activations",
    icon: "rocket",
  },
  {
    type: "collapse",
    name: "Campaigns",
    key: "campaigns",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/campaigns",
    component: <Campaigns />,
    secure: true,
  },
  // {
  //   type: "collapse",
  //   name: "Sales Overview",
  //   key: "dashboard",
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/dashboard",
  //   component: <DashboardOverview />,
  //   secure: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Sales",
  //   key: "sales",
  //   icon: <Icon fontSize="small">list_alt</Icon>,
  //   route: "/sales",
  //   component: <AccountSales />,
  //   secure: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Data Captures",
  //   key: "data-captures",
  //   icon: <Icon fontSize="small">list</Icon>,
  //   route: "/captures",
  //   component: <AllDataCapturesPage />,
  //   secure: true,
  // },
  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small">bar_chart</Icon>,
    route: "/reports",
    component: <ReportFilter />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Customers",
    key: "customers",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/customers",
    component: <Customers />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Customer Pools",
    key: "customer-pools",
    icon: <Icon fontSize="small">how_to_reg</Icon>,
    route: "/customer-pools",
    component: <CustomerPoolsPage />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  // {
  //   type: "collapse",
  //   name: "Bill Back Promotions",
  //   key: "trade-marketing/promotions/bill-back",
  //   icon: <Icon fontSize="small">discount</Icon>,
  //   route: "/trade-marketing/promotions/bill-back",
  //   component: <BillBackPromotionsPage />,
  //   secure: true,
  // },
  {
    type: "collapse",
    name: "Display & Win",
    key: "trade-marketing/promotions/display-win",
    icon: <Icon fontSize="small">leaderboard</Icon>,
    route: "/trade-marketing/promotions/display-win",
    component: <DisplayWinPromotionsPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Product Sampling",
    key: "trade-marketing/promotions/product-sampling",
    icon: <Icon fontSize="small">thumb_up</Icon>,
    route: "/trade-marketing/promotions/product-sampling",
    component: <ProductSamplingPromotionsPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Location Visits",
    key: "visits/trackers",
    icon: <Icon fontSize="small">tour</Icon>,
    route: "/visits/trackers",
    component: <VisitTrackersPage />,
    secure: true,
  },
  {
    type: "group",
    title: "Inventory Management",
    icon: "inventory",
  },
  {
    type: "collapse",
    name: "Products/SKUs",
    key: "products",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/inventory/products",
    component: <Products />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Inventory Trackers",
    key: "products",
    icon: <Icon fontSize="small">track_changes</Icon>,
    route: "/inventory/trackers",
    component: <InventoryTrackersPage />,
    secure: true,
  },
  // {
  //   type: "collapse",
  //   name: "Wholesalers",
  //   key: "trade-marketing/wholesalers",
  //   icon: <Icon fontSize="small">warehouse</Icon>,
  //   route: "/trade-marketing/wholesalers",
  //   component: <WholesalersPage />,
  //   secure: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Retailers",
  //   key: "trade-marketing/retailers",
  //   icon: <Icon fontSize="small">store</Icon>,
  //   route: "/trade-marketing/retailers",
  //   component: <OutletsPage />,
  //   secure: true,
  // },
  // {
  //   type: "group",
  //   title: "Trade Marketing",
  //   icon: "ads_click",
  // },
  // {
  //   type: "collapse",
  //   name: "Bill Back Promotions",
  //   key: "trade-marketing/promotions/bill-back",
  //   icon: <Icon fontSize="small">discount</Icon>,
  //   route: "/trade-marketing/promotions/bill-back",
  //   component: <BillBackPromotionsPage />,
  //   secure: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Display & Win",
  //   key: "trade-marketing/promotions/display-win",
  //   icon: <Icon fontSize="small">leaderboard</Icon>,
  //   route: "/trade-marketing/promotions/display-win",
  //   component: <DisplayWinPromotionsPage />,
  //   secure: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Product Sampling",
  //   key: "trade-marketing/promotions/product-sampling",
  //   icon: <Icon fontSize="small">thumb_up</Icon>,
  //   route: "/trade-marketing/promotions/product-sampling",
  //   component: <ProductSamplingPromotionsPage />,
  //   secure: true,
  // },
  // {
  //   type: "divider",
  //   name: "Divider",
  // },
  // {
  //   type: "collapse",
  //   name: "Wholesalers",
  //   key: "trade-marketing/wholesalers",
  //   icon: <Icon fontSize="small">warehouse</Icon>,
  //   route: "/trade-marketing/wholesalers",
  //   component: <WholesalersPage />,
  //   secure: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Retailers",
  //   key: "trade-marketing/retailers",
  //   icon: <Icon fontSize="small">store</Icon>,
  //   route: "/trade-marketing/retailers",
  //   component: <OutletsPage />,
  //   secure: true,
  // },
  {
    type: "group",
    title: "Team Management",
    icon: "people",
  },
  {
    type: "collapse",
    name: "Agents",
    key: "agents",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/agents",
    component: <Agents />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Agent Groups",
    key: "agent-groups",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/agent-groups",
    component: <AgentGroups />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Execution Partners",
    key: "execution-partners",
    icon: <Icon fontSize="small">folder_shared</Icon>,
    route: "/execution-partners",
    component: <AggregatorsPage />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },

  {
    type: "collapse",
    name: "Attendance Trackers",
    key: "attendances",
    icon: <Icon fontSize="small">recent_actors</Icon>,
    route: "/attendances",
    component: <AttendancesPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Benefits",
    key: "agent-benefits",
    icon: <Icon fontSize="small">money</Icon>,
    route: "/agent-benefits",
    component: <AgentBenefitsPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Trainings",
    key: "trainings",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/trainings",
    component: <Trainings />,
    secure: true,
  },
  {
    type: "group",
    title: "Territory Management",
    icon: "public",
  },
  {
    type: "collapse",
    name: "Territories",
    key: "products",
    icon: <Icon fontSize="small">public</Icon>,
    route: "/geo/territories",
    component: <TerritoriesPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Boundaries",
    key: "products",
    icon: <Icon fontSize="small">polyline</Icon>,
    route: "/geo/boundaries",
    component: <BoundariesPage />,
    secure: true,
  },
  {
    type: "group",
    title: "Lead Management",
    icon: "attribution",
  },
  {
    type: "collapse",
    name: "Profiles",
    key: "leads/profiles",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/leads/profiles",
    component: <LeadProfilesPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Pipelines",
    key: "leads/pipelines",
    icon: <Icon fontSize="small">timeline</Icon>,
    route: "/leads/pipelines",
    component: <LeadPipelinesPage />,
    secure: true,
  },

  {
    type: "group",
    title: "Messaging Center",
    icon: "message",
  },
  {
    type: "collapse",
    name: "Recipients",
    key: "messaging/groups",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/messaging/groups",
    component: <RecipientGroupsPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "History",
    key: "messaging/groups/history",
    icon: <Icon fontSize="small">send</Icon>,
    route: "/messaging/history",
    component: <MessagingHistoryPage />,
    secure: true,
  },
  {
    type: "group",
    title: "Tools",
    icon: "apps",
  },
  {
    type: "collapse",
    name: "Data Forms",
    key: "data-forms",
    icon: <Icon fontSize="small">dynamic_form</Icon>,
    route: "/data-forms",
    component: <DataForms />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Shipping Fees",
    key: "shipping-fees",
    icon: <Icon fontSize="small">local_shipping</Icon>,
    route: "/shipping-fees",
    component: <ShippingRatesPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "API Integration",
    key: "api-integrations",
    icon: <Icon fontSize="small">api</Icon>,
    route: "/api-integrations",
    component: <ApiIntegrationView />,
    secure: true,
  },
  {
    type: "group",
    title: "Accounts & Billing",
    icon: "domain",
  },
  // {
  //   type: "collapse",
  //   name: "Licenses",
  //   key: "licenses",
  //   icon: <Icon fontSize="small">badge</Icon>,
  //   route: "/licenses",
  //   component: <AgentLicensesPage />,
  //   secure: true,
  // },
  {
    type: "collapse",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">payment</Icon>,
    route: "/billing",
    component: <BillingPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Subscriptions",
    key: "campaign-subscriptions",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/campaign-subscriptions",
    component: <CampaignSubscriptionsPage />,
    secure: true,
    plan: "PAG",
  },
  {
    type: "collapse",
    name: "Wallet",
    key: "wallet",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/wallet",
    component: <WalletPage />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Account",
    key: "account",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/account",
    component: <AccountProfile />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <UserProfile />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    component: <Users />,
    secure: true,
  },

  {
    type: "divider",
    name: "Divider",
  },
];

export default routes;
